import { render } from "./FooterLinkSection.vue?vue&type=template&id=24ed26bb"
import script from "./FooterLinkSection.vue?vue&type=script&lang=js"
export * from "./FooterLinkSection.vue?vue&type=script&lang=js"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__